import { __assign } from "tslib";
import _ from 'lodash';
var sentryReporterInstance;
var shouldWrapAsyncFunctionsWithPromise = false;
export function setSentryInstance(sentryInstance) {
    sentryReporterInstance = sentryInstance;
}
export function wrapAsyncFunctionsWithPromise(shouldWrap) {
    shouldWrapAsyncFunctionsWithPromise = shouldWrap;
}
export var wrapTryCatch = function (onCatch) { return function (fn) {
    return function () {
        try {
            return shouldWrapAsyncFunctionsWithPromise
                ? //eslint-disable-next-line prefer-spread,prefer-rest-params
                    Promise.resolve(fn.apply(null, arguments)).catch(onCatch)
                : //eslint-disable-next-line prefer-spread,prefer-rest-params
                    fn.apply(null, arguments);
        }
        catch (e) {
            /* istanbul ignore next: todo: test */
            onCatch === null || onCatch === void 0 ? void 0 : onCatch(e);
        }
    };
}; };
/* istanbul ignore next: todo: test */
export var errorReporter = function (e, rethrowException) {
    if (rethrowException === void 0) { rethrowException = true; }
    sentryReporterInstance === null || sentryReporterInstance === void 0 ? void 0 : sentryReporterInstance.captureException(e);
    if (rethrowException) {
        throw e;
    }
};
export function withErrorReportingWrapping(obj) {
    return withErrorReporting(errorReporter)(obj);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function withErrorReporting(errorReporterFn) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function (obj) {
        var wrapper = wrapTryCatch(errorReporterFn);
        return _.reduce(obj, function (result, value, key) {
            var _a;
            return (__assign(__assign({}, result), (_a = {}, _a[key] = _.isFunction(value) ? wrapper(value) : value, _a)));
        }, {});
    };
}
//# sourceMappingURL=errorReporter.js.map